import type { ReactNode, FC } from 'react';
import c from 'classnames';
import s from './TipDivider.scss';

interface Props {
  className?: string;
  children?: ReactNode;
}

const TipDivider: FC<Props> = ({ className }) => (
  <div className={c(s['root'], className)} role="presentation" />
);
TipDivider.displayName = 'TipDivider';

export default TipDivider;
